import { TRANSLATION_KEYS } from "../../constants";

export function getApproveButtonTooltipTranslationKey(
  hasSCA: boolean,
  isSandbox: boolean,
  isVopPending: boolean = false
) {
  if (isVopPending) {
    return TRANSLATION_KEYS.voltIsVerifyingPayeeDetails;
  }

  if (isSandbox || hasSCA) {
    return null;
  }

  return TRANSLATION_KEYS.scaRequiredToApproveARefund;
}
